// extracted by mini-css-extract-plugin
module.exports = {"courseStatus":"components_courseStatus__1KDj_","courseStatusLive":"components_courseStatusLive__3poH4","courseStatusDraft":"components_courseStatusDraft___xv9o"};